import { useCallback } from 'react'
import ModalSmallFilled from '../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../baseComponents/ModalsLayouts/types'
import { twinFetchPostJSON } from '../../../../../utils/globals/data'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'

interface ModalChangeSpecificPriceRulesProps extends ModalChangeSpecificPriceRulesLogicProps {
}

const ModalChangeSpecificPriceRules: React.FC<ModalChangeSpecificPriceRulesProps> = ({ ...logic }) => {
    const { t } = useTwinTranslation()
    const { handleSpecificPriceRules, handleOnCancel } = useModalChangeSpecificPriceRulesLogic({ ...logic })

    return (
        <ModalSmallFilled translations={{
            title: t('changeCost', 'Se ha cambiado el coste del producto'),
            subtitle: t('sureUpdateSpecificPriceRules', '¿Quieres actualizar las tarifas con coste del producto?'),
            buttonAccept: t('update', 'Actualizar'),
            buttonCancel: t('notRecalculate', 'No recalcular')
        }} onAccept={handleSpecificPriceRules} opened={true} setOpened={logic.setOpened} onClickOut={false} onCancel={handleOnCancel} />
    )
}

interface ModalChangeSpecificPriceRulesLogicProps extends ModalEditComponentProps {
}

const useModalChangeSpecificPriceRulesLogic = ({ allRowData, onSubmit }: ModalChangeSpecificPriceRulesLogicProps) => {
    const handleSpecificPriceRules = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/product/updateProduct', { ...allRowData, updateSpecificPriceRules: true })
        if (result) {
            onSubmit?.(false as any, {})
        }
    }, [onSubmit, allRowData])

    const handleOnCancel = useCallback(async () => {
        if (allRowData?.updateOnCancel) {
            await twinFetchPostJSON('/api/app/product/updateProduct', { ...allRowData, updateSpecificPriceRules: false })
        }
        onSubmit?.(false as any, {})
    }, [onSubmit, allRowData])

    return { handleSpecificPriceRules, handleOnCancel }
}

export default ModalChangeSpecificPriceRules